import { apiRequest } from "./http";
import type { AuthorizeUrlResponse, MicrosoftMailStatus, OkResponse } from "./generated/openapi";
export type { MicrosoftMailStatus } from "./generated/openapi";

export const microsoftMailApi = {
  status: () => apiRequest<MicrosoftMailStatus>("/api/connections/microsoft365/status"),
  connect: () => apiRequest<AuthorizeUrlResponse>("/api/connections/microsoft365/connect", { method: "POST" }),
  disconnect: () => apiRequest<OkResponse>("/api/connections/microsoft365/connection", { method: "DELETE" }),
};
